import React, { useEffect, useState } from "react";
import { Input } from "../ui/input";
import { ShoppingCartOutlined } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import logo from "../../asset/logo.png";
import { Squash as Hamburger } from "hamburger-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { useNavigate } from "react-router-dom";
import { Badge } from "antd";
import { getCategories } from "../../features/categorys/api/getCategories";
import { useAuth } from "../../lib/auth";
import { ComboboxDemo } from "../ui/combox";

export const HeaderTop = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [categoriesData, setCategoriesData] = useState([]);
  const { user, orderCount } = useAuth(); // Using orderCount from AuthContext
  const navigate = useNavigate();

  const handleMenuClick = (id: number) => {
    navigate(`/home/${id}`);
  };

  const handleUserProfile = () => {
    if (user) {
      navigate("/profile");
    } else {
      navigate("/register");
    }
  };

  const handleCategories = async () => {
    const response = await getCategories();
    setCategoriesData(response.data);
  };

  useEffect(() => {
    handleCategories();
  }, []);

  return (
    <header className="relative flex justify-between items-center px-4 bg-white shadow-sm">
      <div
        className="flex items-center space-x-2 cursor-pointer"
        onClick={() => navigate("/home")}
      >
        <img src={logo} alt="Sana Breeze Logo" className="h-8 w-auto" />
      </div>
      <div className="flex justify-center flex-1 md:mx-4 mx-2">
        {/* <Input placeholder="search" className="w-2/3" /> */}
        <ComboboxDemo />
      </div>
      <div className="flex items-center">
        <button className="md:mx-4 mx-2" onClick={() => navigate("/cart")}>
          <Badge count={orderCount}>
            <ShoppingCartOutlined className="h-14 w-14" />
          </Badge>
        </button>
        <button
          className="md:mx-6 mx-0 md:mr-8 mr-2"
          onClick={handleUserProfile}
        >
          <AccountCircleIcon className="h-14 w-14" />
        </button>
        <DropdownMenu open={isMenuOpen} onOpenChange={setMenuOpen}>
          <DropdownMenuTrigger asChild>
            <div
              onClick={() => setMenuOpen((prev) => !prev)}
              className="cursor-pointer"
            >
              <Hamburger size={28} toggled={isMenuOpen} />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-80 max-h-[32rem] overflow-y-auto dropdown-menu-content">
            {categoriesData.map((category: any) =>
              category.is_active ? (
                <DropdownMenuItem
                  key={category.id}
                  className="flex items-center justify-end m-4 py-6 text-right bg-[#303030] text-white cursor-pointer"
                  onClick={() => handleMenuClick(category.id)}
                >
                  {category.name_ar}
                  <img src={category.image_file} className="w-16 h-16" />
                </DropdownMenuItem>
              ) : (
                ""
              )
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};

export const MainLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <HeaderTop />
      {children}
    </div>
  );
};
